import {Button} from 'gatsby-theme-material-ui';
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
  listItemButton: {
    whiteSpace: 'nowrap',
  },
});

const LoginStateCTA = () => {
  // const {apolloLoading} = useApolloLoaderContext();
  // const {page, url, signIn} = usePageContext();
  const classes = useStyles();
  //
  // // non-landing page, not signed in
  // let text = 'Save your progress';
  // const urlParams = url ? `?redirect_to=${url}?signin` : '';
  // let link = `${process.env.GATSBY_MAKESCHOOL_LOGIN_ENDPOINT}${urlParams}`;
  //
  // if (!apolloLoading) {
  //   const {
  //     viewerIs: {isLoggedIn, isStaff, isStudent},
  //   } = useViewer(signIn ? 'cache-and-network' : 'cache-only');
  //
  //   if (signIn) window.history.replaceState({}, '', url.replace('?signin', ''));
  //
  //   if (landing && !isLoggedIn) {
  //     // landing page, not signed in
  //     text = 'Start learning';
  //     link = process.env.GATSBY_START_LEARNING_CTA_LINK;
  //   } else if (isLoggedIn) {
  //     if (page?.course) {
  //       // mediabook course, signed in
  //       text = 'Dashboard';
  //       link = `${page?.course.path}dashboard/`;
  //     } else if (isStudent) {
  //       // student
  //       text = 'Student Portal';
  //       link = `/portal`;
  //     } else if (isStaff) {
  //       // staff
  //       text = 'Admin';
  //       link = `/admin`;
  //     } else {
  //       // signed in user
  //       text = 'Apply to Google CSSI Extension';
  //       link = `/info/google-cssi/`;
  //     }
  //   }
  // }
  //
  // const trackLoginCTA = () => {
  //   window?.analytics?.track('Use LoginStateCTA', {
  //     Text: text,
  //     Link: link,
  //   });
  // };

  return (
    <Button variant="contained" color="primary" to="/tutorials/" className={classes.listItemButton}>
      Tutorials
    </Button>
  );
};

export default LoginStateCTA;
